export const isSmallDesktop = window.innerWidth < 1150
export const isMobile = window.innerWidth < 800

export const width = window.innerWidth
